import React from 'react';

import ClipLoader from 'react-spinners/ClipLoader';

import { Container } from './styles';

export default () => {
    return <Container><ClipLoader color="#7fff00"/></Container>
}